import {
    buildActionCreators,
    makeActionTypes,
    makeAsyncEvents,
    namedParameters,
    noParameters,
    withMeta,
    withPrefill,
} from '../../../common/helpers/ReduxHelpers';

import { DOMAIN } from './Versions.constants';

export const filterEvents = {
    addFilter: namedParameters('field', 'value'),
    removeFilter: namedParameters('field', 'value'),
    setFilter: namedParameters('field', 'value'),
    clearFilter: namedParameters('field'),
    assignFilters: namedParameters('value'),
    resetFilters: noParameters,
};

export const crudEvents = {
    addResult: withMeta(withPrefill(namedParameters('value'), { payload: { field: 'results' } })),
    removeResult: withMeta(
        withPrefill(namedParameters('value'), { payload: { field: 'results' } })
    ),
    filterResults: withMeta(
        withPrefill(namedParameters('value'), { payload: { field: 'results' } })
    ),
};

export const asyncEvents = makeAsyncEvents(['fetchResults', 'create', 'delete'], true);
export const statusEvents = makeAsyncEvents(['retrieve', 'update', 'delete'], true);

export const types = makeActionTypes(
    [
        ...Object.keys(filterEvents),
        ...Object.keys(crudEvents),
        ...Object.keys(asyncEvents),
        ...Object.keys(statusEvents),
    ],
    DOMAIN
);

export default buildActionCreators(
    {
        ...filterEvents,
        ...crudEvents,
        ...asyncEvents,
        ...statusEvents,
    },
    types
);
